// React
import React, {useState } from 'react';
import {Tabs, Tab, Typography, Box } from '@material-ui/core/';
import PropTypes from 'prop-types';

// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Title from 'components/TitleWithIcon';
import FiltrosDelTipoDeReporteDetallado from './FiltrosTipoDeReporteDetallado/index'
import TabMenu from '../MenuListadoReportes'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const ReporteDetalladoAgrupadosPorDepartamentoYGenero = (props) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };    
    return (
        <TabMenu
            componenteEntrante={
                <div>
                    <Title title={props.titulo} icon={"/menu/Estadistica.png"}/>
                    <Tabs style={{backgroundColor: "white"}}
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="REPORTE DETALLADO" {...a11yProps(0)} />
                        {/* <Tab label="REPORTE MUNICIPIO" {...a11yProps(1)} /> */}
                    </Tabs>           
                    <TabPanel value={value} index={0}>
                        <FiltrosDelTipoDeReporteDetallado tipoReporte={value}/>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        Item Two
                    </TabPanel>
                </div>
            }
        />            
    )    
}
export default connect(mapStateToProps, mapDispatchToProps)(ReporteDetalladoAgrupadosPorDepartamentoYGenero);